import React from 'react';

import { LoadingSpinner } from '../../../components/Shared/LoadingSpinner/LoadingSpinner';
import { isProdEnvironment } from '../../../hooks/useEnvironment';

export const bootstrapMockForms = async (): Promise<void> => {
  if (isProdEnvironment()) {
    return;
  }

  await import('./mockFormsFetch');
};

export const MockFormsIndexPage = React.lazy(() => import('./MockFormsIndexPage').then((module) => ({ default: module.MockFormsIndexPage })));

export const MockFormsBoundary = ({ children }: { children: React.ReactNode }) => {
  const [isReady, setIsReady] = React.useState(() => isProdEnvironment());

  React.useEffect(() => {
    if (isProdEnvironment()) {
      return;
    }

    let isMounted = true;

    const bootstrap = async () => {
      try {
        await bootstrapMockForms();
      } catch (error) {
        console.error('Failed to bootstrap mock forms', error);
      } finally {
        if (isMounted) {
          setIsReady(true);
        }
      }
    };

    void bootstrap();

    return () => {
      isMounted = false;
    };
  }, []);

  if (!isReady) {
    return React.createElement(LoadingSpinner);
  }

  return React.createElement(React.Fragment, null, children);
};
